import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Coins } from 'lucide-react';
import type { Payout } from '../types';

const SoldItem = React.memo(({ item }: { item: Payout['itemsSold'][0] }) => {
  return (
    <div className="flex items-center justify-between bg-slate-700/50 rounded-md p-2 text-xs">
      <div className="flex items-center gap-2">
        <span className="text-base">{item.icon}</span>
        <span className="font-medium text-cyan-200">{item.name}</span>
      </div>
      <span className="text-slate-400">x{item.count}</span>
    </div>
  );
});

export function PayoutToast({ payout, onClose }: Props) {
  if (!payout) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 50, scale: 0.9 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 50, scale: 0.9 }}
        className="fixed bottom-20 left-1/2 transform -translate-x-1/2 z-[1500] bg-slate-800/90 backdrop-blur-md rounded-xl p-4 w-[350px] shadow-lg border border-amber-500/50"
      >
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <Coins className="w-6 h-6 text-amber-400" />
            <span className="font-semibold text-lg">Dishes Served!</span>
          </div>
          <span className="font-bold text-xl text-green-400">
            +${payout.amount}
          </span>
        </div>
        <div className="text-xs text-slate-300 mb-3">
          Your trusty server sold some of your creations to hungry customers.
        </div>
        <div>
          <h4 className="font-semibold mb-2 text-amber-300 text-sm">Items Sold:</h4>
          <div className="space-y-1 max-h-32 overflow-y-auto pr-2">
            {payout.itemsSold.map((item) => (
              <SoldItem key={item.id} item={item} />
            ))}
          </div>
        </div>
        <button onClick={onClose} className="w-full text-center mt-4 text-xs text-slate-400 hover:text-white">
          Dismiss
        </button>
      </motion.div>
    </AnimatePresence>
  );
}
